import clamp from 'lodash/fp/clamp';
import range from 'lodash/fp/range';

import { StarFilled } from '@ant-design/icons';

import * as St from './DescriptionAndRating.styles';

import { palette, typography } from '~/theme';

export interface DescriptionAndRatingData {
  description: string;
  rating: {
    text: string;
    value: number;
  };
}

export interface DescriptionAndRatingProps {
  data: DescriptionAndRatingData;
}

const DescriptionAndRating = ({ data }: DescriptionAndRatingProps) => (
  <St.Container>
    <St.Description>{data.description}</St.Description>
    <St.Tooltip
      title={data.rating.text}
      overlayClassName="materials-tooltip"
      overlayInnerStyle={{
        backgroundColor: palette.white,
        border: `0.5px solid ${palette.desertSand}`,
        boxShadow: `0 3px 6px ${palette.black}29`,
        color: palette.erieBlack,
        fontFamily: typography.family.arial,
        fontSize: typography.size14,
      }}
    >
      {range(0, clamp(1, 5, data.rating.value)).map((index) => (
        <StarFilled key={index} aria-hidden="true" />
      ))}
    </St.Tooltip>
  </St.Container>
);

export default DescriptionAndRating;
